import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito comprar comida orgánica cara?',
  a: 'No, el plan funciona con productos básicos de cualquier supermercado en USA.'
}, {
  q: '¿Tengo que hacer ejercicio pesado?',
  a: 'Al contrario, recomendamos caminatas estratégicas. El ejercicio intenso suele ser contraproducente en la fase de reseteo.'
}, {
  q: '¿Es una dieta Keto?',
  a: 'No. Usamos carbohidratos de forma estratégica para proteger tu tiroides.'
}, {
  q: '¿Puedo seguir tomando café?',
  a: 'Sí, pero aprenderás el momento exacto para tomarlo sin bloquear tu quema de grasa.'
}, {
  q: '¿Cuánto tiempo tengo acceso?',
  a: 'El acceso es de por vida una vez descargas el material.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-6 md:px-12 bg-cream" data-id="element-23">
      <div className="max-w-3xl mx-auto" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-26">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-27">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-sm overflow-hidden border border-sage/20" data-id="element-28">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-29">
                <span className="font-bold text-lg text-charcoal pr-4" data-id="element-30">
                  {faq.q}
                </span>
                <ChevronDown className={`text-sage transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-31" />
              </button>
              <AnimatePresence data-id="element-32">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-33">
                    <div className="px-6 pb-5 text-gray-600 border-t border-gray-100 pt-3" data-id="element-34">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}